export const setHighlightBlockStyle = (block, state, username, color) => {
    block.style.outlineColor = color;
    let tag = block.querySelector("g" + ".tag");

    if (!tag) {
        tag = createTagElement(username, color);
        block.appendChild(tag[1]);
        block.appendChild(tag[0]);
    }

    setOutline(block, state, color);
    setTag(tag[1], state, color);
    setTag(tag[0], state, color);
};

export const createTagElement = (username, color) => {
    document.querySelector("rect.blockly-name-tag")?.remove();
    document.querySelector("text.blockly-name-tag")?.remove();

    var text = document.createElementNS("http://www.w3.org/2000/svg", "text");
    text.style.fontFamily = '"Helvetica Neue", Helvetica, Arial, sans-serif';
    text.setAttribute("fill", "white");
    text.style.fontSize = "1.25rem";
    text.style.transform = "translate(.5rem, -1rem)";
    var newUsername = username;
    if (username.length > 12) {
        newUsername = username.slice(0, 12) + "...";
    }
    text.textContent = newUsername;
    text.classList.add("blockly-name-tag");

    var rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    rect.setAttribute("width", "12rem");
    rect.setAttribute("height", "2rem");
    rect.setAttribute("rx", ".5rem");
    rect.classList.add("blockly-name-tag");
    rect.style.transform = "translate(0rem, -2.2rem)";
    rect.setAttribute("fill", color);
    return [text, rect];
};

export function setOutline(block, state, color) {
    document.documentElement.style.setProperty("--stroke-color", color);
    if (state) {
        block.classList.remove("turnOff", "turnedOff");
        block.classList.add("blocRect", "turnOn");
    } else {
        block.classList.remove("turnOn", "turnedOn");
        block.classList.add("blocRect", "turnOff");
    }

    const settle = () => {
        if (state) {
            block.classList.remove("turnOn");
            block.classList.add("turnedOn");
        } else {
            block.classList.remove("turnOff");
            block.classList.add("turnedOff");
        }
    };

    let animation = block
        .getAnimations()
        .find((anim) => anim.animationName?.includes("outline"));

    if (animation) {
        animation.addEventListener("finish", settle);
    } else {
        settle();
    }
}

export function setTag(tag, state) {
    if (state) {
        tag.classList.remove("turnOff");
        tag.classList.add("turnOn");
    } else {
        tag.classList.remove("turnOn");
        tag.classList.add("turnOff");
    }
}
